import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'report-data',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class ReportData extends Vue {

    // ----------------------------------------------------------------------
    // Properties

    private reportMock: any = {
        firstPage: '1',
        secondPage: '4',
    };

    private hoverContent: any = {
        menu1: {
            isHovered: false,
            title: 'Performance',
        },
        menu2: {
            isHovered: false,
            title: 'Math',
        },
        menu3: {
            isHovered: false,
            title: 'Lakeside Middle',
        },
        menu4: {
            isHovered: false,
            title: 'Quarter',
        },
    };

    private metricEvent: any = {
        metrics: [
            { name: 'proficiency' },
            { name: 'portfolio' },
            { name: 'performance', isChecked: true },
            { name: 'time spent' },
        ],
        events: [
            { name: 'login' },
            { name: 'search' },
            { name: 'community' },
            { name: 'suggestion' },
            { name: 'content creation' },
            { name: 'remixes' },
            { name: 'study', isChecked: true },
        ],
    };

    private learningMap: any = {
        collection: [
            { name: 'Collections' },
            { name: 'Assessments' },
            { name: 'Resources' },
            { name: 'Questions' },
            { name: 'Projects' },
            { name: 'Lesson plan' },
            { name: 'Solved examples' },
            { name: 'Practice problems' },
        ],
        category: [
            { name: 'Category/Discipline', isChecked: true },
            {
                name: 'Subject',
                isChecked: true,
                sublist: [{ name: 'ELA' },
                { name: 'Science' },
                { name: 'Math', isChecked: true },
                { name: 'Social Science' },
                ],
            },
            { name: 'Competency', isChecked: true },
        ],
    };

    private users: any = [
        {
            name: 'country',
            activeName: 'United States',
            isChecked: true, subList: [
                { name: 'Canada' },
                { name: 'China' },
                { name: 'Finland' },
                { name: 'India' },
                { name: 'Netherlands' },
                { name: 'Russia' },
                { name: 'United Kingdom' },
                { name: 'United States', isChecked: true },
            ],
        },
        {
            name: 'state',
            activeName: 'California',
            isChecked: true, subList: [
                { name: 'Alabama' },
                { name: 'Alaska' },
                { name: 'California', isChecked: true },
                { name: 'Chhattisgarh' },
                { name: 'Goa' },
                { name: 'Gujarat' },
                { name: 'Tripura' },
                { name: 'Utter Pradesh' },

            ],
        },
        {
            name: 'district',
            activeName: 'Irvine Unified',
            isChecked: true, subList: [
                { name: 'A Center For Creative Education' },
                { name: 'Academy Of Tucson Inc.' },
                { name: 'Baster' },
                { name: 'Durg' },
                { name: 'Irvine Unified', isChecked: true },
                { name: 'Raipur' },
                { name: 'Rajnandgaon' },
            ],
        },
        {
            name: 'school',
            activeName: 'Lakeside Middle',
            isChecked: true, subList: [
                { name: 'Eastwood Elementary' },
                { name: 'Greentree Elementary' },
                { name: 'Irvine High' },
                { name: 'Jeffrey Trail Middle' },
                { name: 'Irvine High' },
                { name: 'Lakeside Middle', isChecked: true },
                { name: 'Meadow Park Elementary' },
            ],
        },
        { name: 'grade', isChecked: true },
        { name: 'class', isChecked: true },
        { name: 'student', isChecked: true }];

    private style: any = {};

    private isChartView: boolean = false;

    private showSubList: any = null;

    // -----------------------------------------------------------------------------
    // Hooks

    private mounted() {
        this.onLoadImage(this.reportMock.firstPage);
        this.showSubList = this.users[3];
        this.$set(this.users[3], 'isActive', true);
    }

    // ---------------------------------------------------------------------
    // Actions
    private onGoBack() {
        Object.keys(this.hoverContent).forEach((content: any) => {
            this.hoverContent[content].isHovered = false;
        });
        const activeUser = this.users.find((user: any) => user.isActive);

        if (activeUser) {
            this.$set(activeUser, 'isActive', false);
        }
        if (!activeUser.isActive) {
            this.$set(this.users[3], 'isActive', true);
            this.showSubList = this.users[3];
        }
        this.onLoadImage(this.reportMock.firstPage);
    }

    private dropdownList(user: any = null) {
        const activeUser = this.users.find((active: any) => active.isActive);
        if (activeUser) {
            this.$set(activeUser, 'isActive', false);
        }
        if (!activeUser.isActive) {
            this.$set(user, 'isActive', true);
        }
        this.showSubList = user && user.subList ? user : null;
    }
    // --------------------------------------------------------------------
    // Methods
    private onLoadImage(imageName: any) {
        this.isChartView = false;
        if (imageName === '4') {
            this.isChartView = true;
        }
        const url = `/img/default-images/data/data${imageName}.png`;
        this.style['background-image'] = `url(${url})`;
        this.readImage(url);
    }

    private readImage(url: string) {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            this.$set(this.style, 'height', img.height + 'px');
        };
    }

    private onHovering(menu: any) {
        this.$set(menu, 'isHovered', true);
    }

}
